/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ResetPassword/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import Email from './Email/index'
import EnsureUrl from 'DesignSystem/EnsureUrl/react'
import React from 'react'
import ResetAction from './ResetAction/index'
import SignInAction from './SignInAction/index'
import TysiaBrandLogo from 'DesignSystem/TysiaBrandLogo/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function ResetPassword({
  children,
  viewPath = "/App/Auth/ResetPassword"
  
}) {
  let isBefore = useIsBefore()
  let isMedia = useIsMedia()
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsWhite1 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white;'
        })
let dtSpaceXl = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xl'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<EnsureUrl
  viewPath={`${viewPath}/EnsureUrl`}
/>
<div
  data-testid="ResetPassword.Vertical"
  data-view-path={viewPath}
 style={{'--bc-3-TVo3T': dtColorsWhite,'--o-1-TVo3T': isBefore ? 0 : 1,'--tx-2-TVo3T': isBefore ? "-32px" : "0px"}}
 className={`views-block ${styles.Vertical}`}
>
<fromFlow.When is={isMedia.desktop}>
<div
  data-testid="ResetPassword.Vertical:1"
  data-view-path={viewPath}
 style={{'--bc-3-TVo3T': dtColorsWhite1,'--pt-4-TVo3T': typeof dtSpaceXl === 'number' ? `${dtSpaceXl}px` : dtSpaceXl,'--pr-5-TVo3T': typeof dtSpaceXl === 'number' ? `${dtSpaceXl}px` : dtSpaceXl,'--pb-6-TVo3T': typeof dtSpaceXl === 'number' ? `${dtSpaceXl}px` : dtSpaceXl,'--pl-7-TVo3T': typeof dtSpaceXl === 'number' ? `${dtSpaceXl}px` : dtSpaceXl}}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="ResetPassword.Vertical:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical2}`}
/>
<TysiaBrandLogo
  viewPath={`${viewPath}/TysiaBrandLogo`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="The extensible, cloud-based orthodontic software with advanced scheduling, communication tools, automations, and seamless integrations"
 color={dtColorsWhite}
 fontSize="22px"
 lineHeight="32px"
/>
</div>
</fromFlow.When>
<div
  data-testid="ResetPassword.Vertical:3"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical3}`}
>
<div
  data-testid="ResetPassword.Vertical:4"
  data-view-path={viewPath}
 style={{'--w-8-TVo3T': isMedia.mobile ? "340px" : "400px"}}
 className={`views-block ${styles.Vertical4}`}
>
<div
  data-testid="ResetPassword.Vertical:5"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h2"
 marginTop={dtSpaceS}
 marginBottom={dtSpaceXxs}
 text="Reset password?"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginBottom={dtSpaceXxs}
 text="Enter your email below and we will send you instructions to change your password."
 color={dtColorsNeutral700}
/>
</div>
<Email
  viewPath={`${viewPath}/Email`}
/>
<div
  data-testid="ResetPassword.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-9-TVo3T': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Horizontal}`}
>
<SignInAction
  viewPath={`${viewPath}/SignInAction`}
/>
<ResetAction
  viewPath={`${viewPath}/ResetAction`}
/>
</div>
</div>
</div>
</div>
{children}
</React.Fragment>)
}